const shadows = {
  primaryButton: '0px 0px 0px rgba(88, 76, 244, 0.25);'
};

export default shadows;
